import { getStaticFilesURL } from './getStaticFilesURL';
import type { Env } from './types';

export const getNothsLogoUrl = (env: Env, port?: string) =>
  getStaticFilesURL(env, 'img/logo/NOTHS_logo_2026-heart.svg', port);
